import Button, {
  ButtonType,
} from "immigram-ui-cmon/src/components/Button/Button";
import Heading, {
  HeadingTag,
} from "immigram-ui-cmon/src/components/Heading/Heading";
import { Icon44Warning } from "immigram-ui-cmon/src/components/Icons";
import Modal from "immigram-ui-cmon/src/components/Modal/Modal";
import Paragraph from "immigram-ui-cmon/src/components/Paragraph/Paragraph";
import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import { ReactNode } from "react";

interface ValidationModalProps {
  gifUrl?: string;
  gifBgPosition?: string;
  heading: ReactNode;
  text: ReactNode;
  open: boolean;
  onCollapse: () => void;
  onGotItClick?: () => void;
  actionButton?: (hideModal: () => void) => ReactNode;
}

const ValidationModal = (props: ValidationModalProps) => {
  return (
    <Modal
      isOpened={props.open}
      panelClassName={clsxm("w-full")}
      onClose={() => {
        props.onCollapse && props.onCollapse();
      }}
    >
      <div
        className={clsxm(
          "group relative z-10 flex w-full flex-col items-center overflow-hidden rounded-2xl bg-white-900 p-8 text-center shadow-sm transition-all"
        )}
      >
        {props.gifUrl !== undefined ? (
          <div
            className="h-[172px] w-[172px] overflow-hidden rounded-full bg-gray-150 bg-cover"
            style={{
              backgroundImage: `url(${props.gifUrl})`,
              backgroundPosition:
                props.gifBgPosition !== undefined ? props.gifBgPosition : "0 0",
            }}
          />
        ) : (
          <div className="flex h-24 w-24 items-center justify-center rounded-[2rem] bg-yellow-50a text-yellow-800">
            <Icon44Warning />
          </div>
        )}

        <Heading tag={HeadingTag.H4} className="mt-5 mb-3">
          {props.heading}
        </Heading>

        <Paragraph className="mb-6">{props.text}</Paragraph>

        <div className="flex justify-center gap-x-2">
          {props.actionButton ? (
            <>
              {props.actionButton(() => props.onCollapse && props.onCollapse())}
            </>
          ) : (
            <Button
              type={ButtonType.Primary}
              onClick={() => {
                props.onGotItClick !== undefined
                  ? props.onGotItClick()
                  : props.onCollapse();
              }}
            >
              Got it
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ValidationModal;
